import React, { useMemo } from "react";

import { Grid } from "@material-ui/core";

import {
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  ResourceContextProvider,
  TextField,
} from "react-admin";

// import { isAuthorized, logError } from "../../../../utils/appUtils";
// import { AclType, InventoryStatus } from "../../../../utils/constants";
import { exceptionRenderer } from "../../../utils/utils";
// import { OpenInventoryItemButton } from "./OpenInventoryItemButton";
import { sortByLocation } from "../../../utils/locationUtils";
import { ageRenderer } from "../../../components/common/AgeRenderer";

export const LocationsPeak = (props) => {
  const { record } = props;

  // Memoize inventoryItems
  const locations = useMemo(() => {
    const inventoryList = record?.inventories?.items ?? [];

    const items = inventoryList.reduce((acc, inventory) => {
      const itemList = inventory?.inventoryItems?.items ?? [];
      const enrichedItems = itemList.map((item) => ({
        ...item,
        inventory: inventory,
      }));
      return acc.concat(enrichedItems);
    }, []);

    const sortedItems = sortByLocation(items, true);
    return { items: sortedItems };
  }, [record]);

  if (locations?.items?.length === 0) return <></>;
  return (
    <ResourceContextProvider value="inventoryItems">
      <Grid container>
        <Grid item xs={false} sm={1}>
          <></>
        </Grid>
        <Grid item xs={12} sm={10}>
          <ArrayField source="items" record={locations} fullWidth>
            <Datagrid>
              <FunctionField
                source="hasException"
                label=" "
                render={exceptionRenderer}
              />
              <TextField
                source="locationFullName"
                label="Location"
                record={locations}
                sortable={false}
              />
              <NumberField
                source="quantityOnHand"
                label="Qty. On Hand"
                sortable={false}
              />
              <NumberField
                source="quantityCommitted"
                label="Qty. Committed"
                sortable={false}
              />
              {/* <NumberField source="pcs" label="Pieces" sortable={false} /> */}
              <TextField
                source="inventory.lotNumber"
                label="Lot Number"
                record={locations}
                sortable={false}
              />
              <TextField
                source="inventory.railCarNumber"
                label="Car/Trl No."
                record={locations}
                sortable={false}
              />
              <FunctionField
                source="inventory.turnDays"
                label="Age"
                sortable={false}
                render={ageRenderer}
              />

              {/* {isAuthorized(AclType.ASSIGN_LOCATION) && (
                <OpenInventoryItemButton
                  inventory={record}
                  backPath={[basePath]}
                />
              )} */}
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={false} sm={3}>
          <></>
        </Grid>
      </Grid>
    </ResourceContextProvider>
  );
};
